import { createAction, props } from '@ngrx/store';
import { User, UserDetails } from 'src/app/shared/models/auth/user';

export const LoggedUser = createAction('[login] Logged User');
export const LoggedUserSuccess = createAction('[Login] Load User Success',
    props<{ user: UserDetails[]}>());
